import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'grab-ui';

import TrackPage from '../pages/track';
import Center from '../components/layout/center';
import useGuid from '../hooks/useGuid';
import useSearchParams from '../hooks/useSearchParams';
import {
  startTrackingInterval,
  stopTrackingInterval,
} from '../actions/api-actions';
import { appDataSelector } from '../selectors/app-data-selector';
import { useAuthModule } from '../hooks/native';
import fetchData from '../common/utils/fetch-data';
import { FETCH_DATA_TYPE } from '../constants/fetch-data';

import styles from './entry-view.less';

const EntryView = () => {
  const dispatch = useDispatch();
  const guid = useGuid();
  const [searchParams] = useSearchParams();
  const { getAccessToken, inApp } = useAuthModule();
  const isFirstMount = useRef(true);

  const {
    isLoadingInitData,
    isLoadedInitData,
    isErrorInitData,
    isErrorDynamicData,
    isErrorFullData,
    isExpiredGuid,
    trackingInterval,
    fetchInterval,
  } = useSelector(appDataSelector);
  useEffect(
    () => {
      if (isFirstMount.current) isFirstMount.current = false;

      fetchData({
        type: FETCH_DATA_TYPE.INIT,
        dispatch,
        inApp,
        guid,
        searchParams,
        getAccessToken,
      });
    },
    [guid, inApp],
  );

  const isError = isErrorInitData || isErrorDynamicData || isErrorFullData;

  useEffect(
    () => {
      const shouldStartInterval =
        isLoadedInitData &&
        !trackingInterval &&
        !isErrorInitData &&
        !isExpiredGuid;

      if (shouldStartInterval) {
        const intervalId = setInterval(() => {
          fetchData({
            type: FETCH_DATA_TYPE.FULL,
            dispatch,
            inApp,
            guid,
            searchParams,
            getAccessToken,
          });
        }, fetchInterval);
        dispatch(startTrackingInterval({ intervalId }));
      }

      return () => {
        if (trackingInterval) {
          clearInterval(trackingInterval);
          dispatch(stopTrackingInterval());
        }
      };
    },
    [isLoadedInitData, isError, isExpiredGuid, guid, fetchInterval, inApp],
  );

  if (isFirstMount.current || isLoadingInitData)
    return (
      <Center className={styles.fullHeight}>
        <Spin />
      </Center>
    );

  return <TrackPage isError={isError} isExpired={isExpiredGuid} guid={guid} />;
};

export default EntryView;
